import { Button } from "@material-ui/core";
import styled from "styled-components";

export const InstallBanner = styled.div`
    position: fixed;
    bottom: ${props => props.show ? '20px' : '-200px'};
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%);
    color: white;
    padding: 16px 24px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    gap: 16px;
    z-index: 9999;
    max-width: 90%;
    width: 500px;
    transition: bottom 0.3s ease-in-out;

    @media (max-width: 768px) {
        width: calc(100% - 40px);
        flex-direction: column;
        gap: 12px;
        padding: 16px;
    }
`;

export const BannerContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const BannerTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
`;

export const BannerDescription = styled.div`
    font-size: 14px;
    opacity: 0.9;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;

    @media (max-width: 768px) {
        width: 100%;
        justify-content: space-between;
    }
`;

export const StyledButton = styled(Button)`
    && {
        color: white;
        border-color: white;
        text-transform: none;
        font-weight: 500;

        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
            border-color: white;
        }
    }
`;

export const InstallButton = styled(Button)`
    && {
        background-color: white;
        color: #000000;
        text-transform: none;
        font-weight: 600;
        padding: 8px 20px;

        &:hover {
            background-color: #f0f0f0;
        }
    }
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }

    @media (max-width: 768px) {
        position: absolute;
        top: 12px;
        right: 12px;
    }
`;
